/*
========================================================

Velora Gallery Engine v2.0

Controls ONLY the gallery.

========================================================
*/

window.VeloraGallery = (function () {

    let mainImage = null;
    let thumbnails = [];

    function init() {

        mainImage = document.getElementById("vblMainImage");

        thumbnails = Array.from(
            document.querySelectorAll(
                ".vbl-product-gallery__thumb"
            )
        );

        if (!mainImage) return;

        thumbnails.forEach((thumb) => {

            thumb.addEventListener("click", function () {

                setImage(
                    this.dataset.image,
                    this.dataset.mediaId
                );

            });

        });

    }

    function setImage(imageUrl, mediaId) {

        if (!mainImage) return;

        mainImage.src = imageUrl;

        thumbnails.forEach((thumb) => {

            thumb.classList.remove("is-active");

            if (thumb.dataset.mediaId == mediaId) {

                thumb.classList.add("is-active");

            }

        });

    }

    return {

        init,

        updateFromVariant(option) {

            if (!option) return;

            setImage(

                option.dataset.image,

                option.dataset.imageId

            );

        }

    };

})();

document.addEventListener(

    "DOMContentLoaded",

    function () {

        VeloraGallery.init();

    }

);